<template>
	<v-container class="noMargin">
		<v-layout row wrap>
			<v-flex lg12>
				<div class="pageTitle quoteLiteTitle" style="max-width:100% !important;width: 100% !important">
					<h2>QUOTES REPORT</h2>
          <!--<h3 style="display: block; float: left;padding-top: 4px;margin-right:20px;">Quote Date</h3>
          <h4 style="display: block; float: left;padding-top: 8px;">{{ fncGetFilterDates() }}</h4>-->
          <!--<v-progress-circular v-show="excelLoading == true" style="display: block; float: left !important;margin-left: 72% !important; margin-top: 12px;" indeterminate :width="3" :size="20" color="grey" class="pt-3 loginLoader"></v-progress-circular>-->
          <!--<v-btn v-if="quotesLoaded == true && objAuthorize.privileges.indexOf('CAN_SEARCH_ARCHIVE') != -1" @click.prevent="fncShowArchives()" class="elevation-5" color="info"><i class="material-icons">search</i>SEARCH ARCHIVED </v-btn>
          <v-btn v-if="quotesLoaded == true && objAuthorize.privileges.indexOf('CAN_SUMMARY_REPORTING') != -1" @click.prevent="fncShowSummaryReporting" class="elevation-5" color="info"><i class="material-icons">summarize</i>SUMMARY REPORTING </v-btn>
          <v-btn @click.prevent="fncExportQuotes" v-show="quotesLoaded == true && excelLoading == false" class="elevation-5" color="info"><img src="../../shared/assets/images/icons/csv.svg" class="customIcon" width="16" />EXPORT TO EXCEL</v-btn>
          <v-btn @click.prevent="fncShowColumns" v-if="quotesLoaded == true" class="elevation-5" color="info"><i class="material-icons">view_column</i>MANAGE COLUMNS</v-btn>-->

				</div>
				<!--<v-btn @click.prevent="fncShowFilter" class="elevation-5" color="info"><i class="material-icons">filter_list</i>FILTER / GENERATE REPORT</v-btn>-->
               <!-- <v-btn @click.prevent="fncShowColumns" class="elevation-5" color="info"><i class="material-icons">view_column</i>MANAGE COLUMNS</v-btn>
				<v-btn @click.prevent="fncReloadQuotes" class="elevation-5" color="info reloadButton"><i class="material-icons">refresh</i></v-btn>-->
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
	export default {
		name: 'QuoteLiteHeader',
		data () {
			return {
              columnLengths: [],
              objCustomerRegion: window.localStorage.qRegion != undefined && window.localStorage.qRegion[0] != null ? window.localStorage.qRegion.split(',') : '',
              objOriginator: window.localStorage.reportOriginators != undefined && window.localStorage.reportOriginators[0] != null ? JSON.parse(window.localStorage.reportOriginators) : '',
              objStatus: window.localStorage.reportStatus != undefined && window.localStorage.reportStatus[0] != null ? JSON.parse(window.localStorage.reportStatus) : '',
              objCustomerCompany: window.localStorage.reportCompanies != undefined && window.localStorage.reportCompanies[0] != null ? JSON.parse(window.localStorage.reportCompanies) : '',
              objCustomerUser: window.localStorage.reportUsers != undefined && window.localStorage.reportUsers[0] != null ? JSON.parse(window.localStorage.reportUsers) : '',
              objProject: window.localStorage.reportProject != undefined && window.localStorage.reportProject[0] != null ? JSON.parse(window.localStorage.reportProject) : '',
              objCompany: window.localStorage.reportCompany != undefined && window.localStorage.reportCompany[0] != null ? JSON.parse(window.localStorage.reportCompany) : '',
              objSpecifier: window.localStorage.reportSpecifiers != undefined && window.localStorage.reportSpecifiers[0] != null ? JSON.parse(window.localStorage.reportSpecifiers) : '',
              objVendor: window.localStorage.reportVendors != undefined && window.localStorage.reportVendors != null ? JSON.parse(window.localStorage.reportVendors) : ['all'],
              objDepartment: window.localStorage.reportDepartments != undefined && window.localStorage.reportDepartments != null ? JSON.parse(window.localStorage.reportDepartments) : ['all'],
              objStore: window.localStorage.reportStores != undefined && window.localStorage.reportStores != null ? JSON.parse(window.localStorage.reportStores) : ['all'],
              objSpecifier: window.localStorage.reportSpecifiers != undefined && window.localStorage.reportSpecifiers[0] != null ? JSON.parse(window.localStorage.reportSpecifiers) : '',
              objKam: window.localStorage.reportKams != undefined && window.localStorage.reportKams != null ? JSON.parse(window.localStorage.reportKams) : ['all'],
              objcOriginator: window.localStorage.reportcOriginator != undefined && window.localStorage.reportcOriginator != null ? JSON.parse(window.localStorage.reportcOriginator) : ['all'],
              objQuoteType: ((window.localStorage.reportQuoteType != undefined || window.localStorage.reportQuoteType !== 'undefined') && window.localStorage.reportQuoteType != null) ?
                JSON.parse(window.localStorage.reportQuoteType) : ['all'],
              objServiceType: window.localStorage.reportServiceType != undefined && window.localStorage.reportServiceType != null ? JSON.parse(window.localStorage.reportServiceType) : ['all'],
              startDate: window.localStorage.qStartDate,
              endDate: window.localStorage.qEndDate,
              reportDate: window.localStorage.reportDates != undefined && window.localStorage.reportDates != null ? this.setDates() : '',
              objRegion: window.localStorage.reportRegions != undefined && window.localStorage.reportRegions != null ? JSON.parse(window.localStorage.reportRegions) : ['all'],
              objRep: window.localStorage.reportReps != undefined && window.localStorage.reportReps != null ? JSON.parse(window.localStorage.reportReps) : ['all']
			}
		},
		methods: {
      fncShowArchives() {
        var modalDetails = { title: 'Archived Quotes', component: 'modal-archived-quotes', mstate: true, params: {} };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncShowSummaryReporting() {
        var modalDetails = { title: 'Summary Reporting', component: 'modal-summary-reporting', mstate: true, params: {} };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      setDates() {
        return window.localStorage.reportDates.split(',');
      },
      fncGetFilterDates() {
        if( this.reportDate[0] == '' || this.reportDate[1] == '' ) {
          return 'All Dates';
        } else {
          var startDate = new Date(this.reportDate[0]);
          startDate.setDate(startDate.getDate() + 1);
          startDate = new Date(startDate + ' GMT +0200').toISOString().slice(0, 10);

          var endDate = new Date(this.reportDate[1]);
          endDate.setDate(endDate.getDate() + 1);
          endDate = new Date(endDate + ' GMT +0200').toISOString().slice(0, 10);

          return startDate + ' to ' + endDate;
        }
      },
			fncShowFilter() {
				var modalDetails = { title: 'Generate / Filter Report', component: 'modal-filter-quotes', mstate: true, params: {} };
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
          },
            fncShowColumns() {
              var modalDetails = { title: 'Filter Columns', component: 'modal-filter-columns', mstate: true, params: {} };
              this.$store.commit({
                type: 'setModal',
                details: modalDetails
              });
            },
            fncReloadQuotes() {
              this.$store.commit('fncEmptyQuoteList');
              this.$store.commit('fncSetQuoteReportLoaded', false);
              this.$store.dispatch({
                type: 'fncPopulateQuoteList',
                date_from: this.startDate == '' || this.startDate == undefined ? 'null' : this.startDate,
                date_to: this.endDate == '' || this.endDate == undefined ? 'null' : this.endDate,
                // region: this.objCustomerRegion == '' || this.objCustomerRegion[0] == 'null' ? 'null' : this.objCustomerRegion,
                status: this.objStatus == '' || this.objStatus[0] == 'null' ? 'null' || this.objStatus[0] == 'null' : this.objStatus,
                originator: this.objOriginator == '' || this.objOriginator[0] == 'null' || this.objOriginator[0] == 'null' ? 'null' : this.objOriginator,
                customer: this.objCustomerUser == '' || this.objCustomerUser[0] == 'null' || this.objCustomerUser[0] == 'null' ? 'null' : this.objCustomerUser,
                project: this.objProject == '' || this.objProject[0] == 'null' || this.objProject[0] == 'null' ? 'null' : this.objProject,
                company: this.objCompany == '' || this.objCompany[0] == 'null' || this.objCompany[0] == 'null' ? 'null' : this.objCompany,
                // company: this.objCustomerCompany == '' || this.objCustomerCompany[0] == 'null' || this.objCustomerCompany[0] == 'null' ? 'null' : this.objCustomerCompany,
                specifier: this.objSpecifier == '' || this.objSpecifier[0] == 'null' || this.objSpecifier[0] == 'null' ? 'null' : this.objSpecifier,
                quoteRegion: this.objRegion[0] == 'all' ||this.objRegion == '' || this.objRegion[0] == 'null' || this.objRegion[0] == 'null' ? 'null' : this.objRegion,
                quoteRep: this.objRep[0] == 'all' ||this.objRep == '' || this.objRep[0] == 'null' || this.objRep[0] == 'null' ? 'null' : this.objRep,
                commercial_kam: this.objKam[0] == 'all' ||this.objKam == '' || this.objKam[0] == 'null' || this.objKam[0] == 'null' ? 'null' : this.objKam,
                commercial_originator: this.objcOriginator[0] == 'all' ||this.objcOriginator == '' || this.objcOriginator[0] == 'null' || this.objcOriginator[0] == 'null' ? 'null' : this.objcOriginator,
                quote_type: this.objQuoteType[0] == 'all' ||this.objQuoteType == '' || this.objQuoteType[0] == 'null' || this.objQuoteType[0] == 'null' ? 'null' : this.objQuoteType,
                service_type: this.objServiceType[0] == 'all' ||this.objServiceType == '' || this.objServiceType[0] == 'null' || this.objServiceType[0] == 'null' ? 'null' : this.objQuoteType,
                reload: true,
                start_date: localStorage.getItem("quote_start_date"),
                end_date: localStorage.getItem("quote_end_date")
              })
            },
            fncExportQuotes() {
              this.$store.commit('fncExcelLoading', true);
              this.$store.dispatch({
                type: 'fncDoQuoteReportExcel',
                status: this.objStatus == '' || this.objStatus[0] == 'null' ? 'null' || this.objStatus[0] == 'null' : this.objStatus,
                originator: this.objOriginator == '' || this.objOriginator[0] == 'null' || this.objOriginator[0] == 'null' ? 'null' : this.objOriginator,
                department: this.objDepartment[0] == 'all' || this.objDepartment == '' || this.objDepartment[0] == 'null' || this.objDepartment[0] == 'null' ? 'null' : this.objDepartment,
                customer: this.objCustomerUser == '' || this.objCustomerUser[0] == 'null' || this.objCustomerUser[0] == 'null' ? 'null' : this.objCustomerUser,
                company: this.objCustomerCompany == '' || this.objCustomerCompany[0] == 'null' || this.objCustomerCompany[0] == 'null' ? 'null' : this.objCustomerCompany,
                specifier: this.objSpecifier == '' || this.objSpecifier[0] == 'null' || this.objSpecifier[0] == 'null' ? 'null' : this.objSpecifier,
                vendor: this.objVendor == '' || this.objVendor[0] == 'null' || this.objVendor[0] == 'null' ? 'null' : this.objVendor,
                store: this.objStore[0] == 'all' ||this.objStore == '' || this.objStore[0] == 'null' || this.objStore[0] == 'null' ? 'null' : this.objStore,
                quoteRegion: this.objRegion[0] == 'all' ||this.objRegion == '' || this.objRegion[0] == 'null' || this.objRegion[0] == 'null' ? 'null' : this.objRegion,
                quoteRep: this.objRep[0] == 'all' ||this.objRep == '' || this.objRep[0] == 'null' || this.objRep[0] == 'null' ? 'null' : this.objRep,
                commercial_kam: this.objKam[0] == 'all' ||this.objKam == '' || this.objKam[0] == 'null' || this.objKam[0] == 'null' ? 'null' : this.objKam,
                commercial_originator: this.objcOriginator[0] == 'all' ||this.objcOriginator == '' || this.objcOriginator[0] == 'null' || this.objcOriginator[0] == 'null' ? 'null' : this.objcOriginator,
                quote_type: this.objQuoteType[0] == 'all' ||this.objQuoteType == '' || this.objQuoteType[0] == 'null' || this.objQuoteType[0] == 'null' ? 'null' : this.objQuoteType,
                service_type: this.objServiceType[0] == 'all' ||this.objServiceType == '' || this.objServiceType[0] == 'null' || this.objServiceType[0] == 'null' ? 'null' : this.objQuoteType,
                start_date: localStorage.getItem("quote_start_date"),
                end_date: localStorage.getItem("quote_end_date")
              })

				/*var reportData = [];
					reportData.push(['QUOTE DATE', 'QUOTE NO.', 'ORIGINATOR TYPE', 'ORIGINATOR', 'CUSTOMER TYPE', 'CUSTOMER', 'CUSTOMER MANAGER', 'DISCOUNT (R/c)', 'SUB TOTAL', 'TAX VALUE', 'GRAND TOTAL', 'STATUS', 'ROJECT REGION', 'ORIGINATOR REGION', 'PROJECT', 'SPECIFIER', 'RESPONSIBLE REP', 'FOLLOW UP']);

				for (var q in this.quoteList) {
					var toPush = [];
					var projectRegion = '-';
					if (this.quoteList[q].project_region != null) {
						projectRegion = this.quoteList[q].project_region.replace(/,/g, ' | ')
					}

					toPush.push(this.quoteList[q].quote_date);
					toPush.push(this.quoteList[q].quote_no);
					toPush.push(this.quoteList[q].orig_type);
					toPush.push(this.quoteList[q].orig_name);
					toPush.push(this.quoteList[q].customer_type);
					toPush.push(this.quoteList[q].customer_name);
					toPush.push(this.quoteList[q].customer_manager);
					toPush.push('R' + this.quoteList[q].discount_val);
					toPush.push('R' + this.quoteList[q].pricing_subtotal);
					toPush.push('R' + this.quoteList[q].pricing_vat);
					toPush.push('R' + this.quoteList[q].pricing_total);
					toPush.push(this.quoteList[q].status);
					toPush.push(projectRegion);
					toPush.push(this.quoteList[q].originator_region);
					toPush.push(this.quoteList[q].project.replace(/,/g, ' | '));
					toPush.push(this.quoteList[q].specifier);
					toPush.push(this.quoteList[q].responsible_representative.replace(/,/g, ' | '));
					toPush.push(this.quoteList[q].pmoc);

					reportData.push( toPush );

				}

				this.$store.dispatch('fncReturnExcel', reportData);*/

            }
        },
        computed: {
          ...mapGetters([
            'objAuthorize',
            'quoteList',
            'excelLoading',
            'quotesLoaded',
            'globalModalTitle',
            'quotesLoaded'
          ])
        },
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>
